import React, { createContext, useEffect, useState } from "react";

export const CatalogContext = createContext();

const apiUrl = process.env.REACT_APP_API_BASE_URL;
const token = localStorage.getItem("token");

const CatalogProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const getCatalogMastersById = async (masterKeys) => {
    const loop = masterKeys.map((id) => `masterId=${id}`).join("&");
    const url = `${apiUrl}/api/catalogs?${loop}`;

    const response = await fetch(url, {
      headers: {
        Accept: "application/json",
        Authorization: `${token}`,
      },
    });

    const data = await response.json();
    localStorage.setItem("catalogValues", JSON.stringify(data));
  };

  const getCatalogMasters = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/catalogmasters`);
      const data = await response.json();

      localStorage.setItem("catalogMaster", JSON.stringify(data.inverted));
      const masterKeys = Object.keys(data.index);

      await getCatalogMastersById(masterKeys);

      setLoading(false);
    } catch (error) {
      console.error("Catalog fetch error:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // Call only if not in localStorage
    const master = localStorage.getItem("catalogMaster");
    const values = localStorage.getItem("catalogValues");

    if (!master || !values) {
      getCatalogMasters();
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <CatalogContext.Provider value={{ loading }}>
      {children}
    </CatalogContext.Provider>
  );
};

export default CatalogProvider;
